import { render, staticRenderFns } from "./usersform.vue?vue&type=template&id=03a888c6&"
import script from "./usersform.vue?vue&type=script&lang=ts&"
export * from "./usersform.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports